import { PlannerItemStatusesEnum } from '../enums/plannerItemStatuses.enum';

import type { TaskItemModel } from '../models/tasks/taskItem.model';

interface PlannerItemStatus {
  data: TaskItemModel[];
  id: PlannerItemStatusesEnum;
  label: string;
  isListOver: boolean;
}

type PlannerData = {
  [key in PlannerItemStatusesEnum]: PlannerItemStatus;
};
export const findColumnIdByTaskId = (data: PlannerData, taskId: number) => {
  const foundColumnId = data
    ? // eslint-disable-next-line @typescript-eslint/no-unused-vars
      Object.entries(data).find(([columnId, column]) => column.data.some((task) => task.id === taskId))
    : [PlannerItemStatusesEnum.todo];

  if (foundColumnId) {
    return PlannerItemStatusesEnum[foundColumnId[0] as keyof typeof PlannerItemStatusesEnum];
  }

  return null;
};
